import { Badge, Button, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { enderecoCurto, formatarMoeda, statusDoImovel } from './formatos';
import { aoErroImagem, urlOtimizada } from '../../lib/imagem';

// Tabela de imóveis com foto/tipo/endereço/valor — extraída de ListaImoveis.js (22/10/2026) pra
// ficar igual em três lugares: a listagem de Imóveis, a busca geral do Dashboard e a lista de
// "imóveis vinculados" na tela do cliente (proprietário). Clicar na linha abre a janela rápida
// (`aoAbrir`, o mesmo `DetalheImovel` que cada tela já usa); o botão "Editar" vai pra edição.
export default function TabelaImoveis({ imoveis, usuario, aoAbrir }) {
  if (imoveis.length === 0) return null;
  return (
    <Table hover responsive className="align-middle">
      <thead>
        <tr>
          <th style={{ width: 140 }}>Imagem</th>
          <th>Referência</th>
          <th>Tipo</th>
          {usuario.nivel === 1 && <th>Empresa</th>}
          <th style={{ minWidth: 300 }}>Endereço</th>
          <th style={{ minWidth: 130 }}>Valor</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {imoveis.map((im) => {
          const st = statusDoImovel(im);
          const fim = enderecoCurto(im);
          return (
            <tr key={im.public_id} style={{ cursor: 'pointer', backgroundColor: st.fundo }} onClick={() => aoAbrir(im.public_id)}>
              <td>
                <div style={{ borderLeft: `6px solid ${st.cor}`, paddingLeft: 6 }}>
                  {im.capa_url ? (
                    <img
                      src={urlOtimizada(im.capa_url, 240, { quadrada: true })}
                      onError={aoErroImagem(im.capa_url)}
                      alt=""
                      loading="lazy"
                      width="120"
                      height="120"
                      style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 4, display: 'block' }}
                    />
                  ) : (
                    <div className="bg-light border text-muted small d-flex align-items-center justify-content-center" style={{ width: 120, height: 120, borderRadius: 4 }}>
                      sem foto
                    </div>
                  )}
                </div>
              </td>
              <td>
                <div>{im.i1_codsequencia}</div>
                <Badge bg={st.bg}>{st.rotulo}</Badge>
                {im.i1_bloqueio === 'true' && <Badge bg="dark" className="ms-1">Bloqueado</Badge>}
              </td>
              <td className="text-uppercase">{im.t1_descricao}</td>
              {usuario.nivel === 1 && <td>{im.empresa_nome}</td>}
              <td>
                {im.i1_seotitulo && <strong>{im.i1_seotitulo}<br /></strong>}
                {fim.rua}
                <br />
                {fim.bairro && `${fim.bairro} - `}
                {fim.cidade}
              </td>
              <td>
                {formatarMoeda(im.i1_vlrvenda)}
                {Number(im.i1_locacao) > 0 && <div className="small text-muted">Loc.: {formatarMoeda(im.i1_locacao)}</div>}
              </td>
              <td className="text-end text-nowrap" onClick={(e) => e.stopPropagation()}>
                {im.pode_editar && (
                  <Button as={Link} to={`/imoveis/${im.public_id}`} size="sm" variant="outline-secondary">
                    Editar
                  </Button>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}
